import axios from "axios";
import { aspNetUrl, newApiBaseUrl } from "../../axiosInstance";

export const getInventoriesPerMktOrBarcode = (mkt, barcode, tr, stationId) => {
  mkt = mkt ? mkt : 0;
  return axios.get(
    `${aspNetUrl}InventoryLocation/GetInventorysPerMktOrBarcode?mkt=${mkt}&barcode=${barcode}&whithEmptyPlace=${tr}&stationId=${stationId}`,
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};

export const multiMoves = (data) => {
  return axios.post(`${aspNetUrl}InventoryLocation/MultyMoves`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const updateProductBox = (data) => {
  return axios.post(`${aspNetUrl}Product/UpdateProductBox`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const updateDateEndSpecial = (data) => {
  return axios.post(
    `${aspNetUrl}InventoryLocation/UpdateDateEndSepcial`,
    data,
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};

export const InventoryTransfers = async (data) => {
  const response = await fetch(`${newApiBaseUrl}/common/inventory-movements`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.jwtToken}`,
      "x-tenant": "hamazon",
    },
    body: JSON.stringify(data),
  });
  return response;
};

export const InventoryBatches = (barcode, locationId) => {
  return axios.get(
    `${newApiBaseUrl}/common/inventory-batches?locationId=${locationId}&productId=${barcode}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    },
  );
};

const unwrapInventoryPayload = (raw) => {
  if (!raw || typeof raw !== "object") return null;
  if (
    "totalInventory" in raw ||
    "availableInventory" in raw ||
    "availabilityRecord" in raw
  ) {
    return raw;
  }
  if (raw.data && typeof raw.data === "object") {
    return unwrapInventoryPayload(raw.data);
  }
  return raw;
};

const inventoryAuthHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.jwtToken}`,
  "X-Tenant": "hamazon",
});

const availabilityRebuildUrl = (locationId) => {
  const params = new URLSearchParams({ locationId: String(locationId) });
  return `${newApiBaseUrl}/inventory/availability/rebuild?${params}`;
};

const unwrapRebuildPayload = (raw) => {
  if (!raw || typeof raw !== "object") return null;
  if (raw.summary && typeof raw.summary === "object") return raw;
  if (raw.data && typeof raw.data === "object")
    return unwrapRebuildPayload(raw.data);
  return raw;
};

/** Returns a flat inventory object (not axios response / nested data wrappers). */
export const getProductInventory = async (productId, locationId) => {
  const params = new URLSearchParams({ locationId: String(locationId) });
  const res = await axios.get(
    `${newApiBaseUrl}/inventory/products/${encodeURIComponent(productId)}/inventory?${params}`,
    { headers: inventoryAuthHeaders() },
  );
  return unwrapInventoryPayload(res?.data);
};

/** Location-wide plan. Does not write. */
export const fetchAvailabilityRebuildPlan = async (locationId) => {
  const res = await axios.get(availabilityRebuildUrl(locationId), {
    headers: inventoryAuthHeaders(),
  });
  return unwrapRebuildPayload(res?.data);
};

/** Location-wide apply. Caller must confirm the plan first. */
export const applyAvailabilityRebuild = async (locationId) => {
  const res = await axios.post(availabilityRebuildUrl(locationId), null, {
    headers: inventoryAuthHeaders(),
  });
  return unwrapRebuildPayload(res?.data);
};

export const getProductAvailability = (productId, locationId) => {
  return axios.get(
    `${newApiBaseUrl}/products/availability/${productId}/locations/${locationId}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    },
  );
};

export const InventoryPerProduct = (barcode, locationId) => {
  return axios.get(
    `${newApiBaseUrl}/common/inventory-spots?locationId=${locationId}&productId=${barcode}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    },
  );
};

export const fetchZonesByLocationId = async (locationId) => {
  return axios.get(`${newApiBaseUrl}/common/zones?locationId=${locationId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const getInventorySpots = (zoneId) => {
  return axios.get(`${newApiBaseUrl}/common/inventory-spots?zoneId=${zoneId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const getRcks = (zoneId) => {
  return axios.get(`${newApiBaseUrl}/common/racks?zoneId=${zoneId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const getShelves = (rackId) => {
  return axios.get(`${newApiBaseUrl}/common/shelves?rackId=${rackId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const getSpots = (shelfId) => {
  return axios.get(`${newApiBaseUrl}/common/spots?shelfId=${shelfId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const getSaveLocations = (stationId) => {
  return axios.get(
    `${aspNetUrl}Inventory/GetSaveLocations?stationId=${stationId}`,
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};

export const getIfProductPlaceFailedEmpty = (mkt) => {
  return axios.get(
    `${aspNetUrl}InventoryLocation/GetIfProductPlaceFailedsEmpty?mkt=${mkt}`,
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};

export const getEmptyPlace = (mkt, stationId) => {
  return axios.get(
    `${aspNetUrl}InventoryLocation/FindEmptyPlaces?mkt=${mkt}&stationId=${stationId}`,
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};
export const getInventoryPerLocation = (Colmon, Row, Cell, stationId) => {
  return axios.get(
    `${aspNetUrl}Inventory/GetInventoryPerLocation?Colmon=${Colmon}&Row=${Row}&Cell=${Cell}&stationId=${stationId}`,
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};

export const updateInventoryBatchExpiration = async (batchId, expiration) => {
  const res = await axios.patch(
    `${newApiBaseUrl}/common/inventory-batches/${batchId}`,
    {
      expiration,
    },
    {
      headers: {
        "x-tenant": "hamazon",
        Authorization: `bearer ${localStorage.jwtToken}`,
      },
    },
  );

  return res.data;
};
